<template>
  <NuxtImg class="base-image" v-bind="attrs" />
</template>

<script lang="ts">
  /**
   * This component exists as a light wrapper around `<NuxtImg>`, as `<NuxtImg>` itself has very relaxed props requirements
   * Our goal is to make certain props required that contribute to CLS avoidance (`width` & `height`) & accessibility (`alt`)
   */
  export type Props = LooselyBindable<NuxtImgProps>;
</script>

<script setup lang="ts">
  const props = defineProps</* @vue-ignore */ Props>(); /* eslint-disable-line @typescript-eslint/no-unused-vars */

  const attrs = useAttrs() as typeof props;
</script>
